<div class="gap-xl flex w-full flex-col items-center justify-center pt-20">
  <bx-file-upload
    acceptedFileTypes=".xml"
    [inputAriaLabel]="'elsImport.aria.fileUpload' | translate"
    [content]="contentInfo"
    [multiple]="true"
    [uploadStatus]="fileUploadStatus()"
    (fileChanged)="onFileChanged($event)"
  >
    <ng-template #contentInfo>
      <div class="text-text-tertiary-600 flex flex-col items-center text-sm">
        <p><span class="text-button-tertiary-color-fg">Click to upload</span> or drag and drop</p>
        <p>XML</p>
      </div>
    </ng-template>
  </bx-file-upload>

  <div class="w-[512px]">
    <bx-input [label]="'KEK'">
      <input #bxInput placeholder="kek" [formControl]="kek" />
    </bx-input>
  </div>

  @if (filesToUpload(); as files) {
    <button bx-button iconTrailing="upload-03" (click)="importFile(files.item(0)!)" [disabled]="uploading() || !kek.value">
      {{ 'elsImport.upload' | translate }}
    </button>
  }

  @if (errorKey(); as errorKey) {
    <p class="text-error-700 text-sm font-medium">{{ errorKey | translate }}</p>
  }
</div>
